(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[-’']/g, ' ').replace(/\s+/g, ' ').trim();
  const tileTemplate = value => String(value || '').trim().replace(/%7B/gi, '{').replace(/%7D/gi, '}');
  const coordinates = card => {
    const {lat, lng} = card.dataset;
    const point = [Number(lat), Number(lng)];
    return lat?.trim() && lng?.trim() && point.every(Number.isFinite) && Math.abs(point[0]) <= 90 && Math.abs(point[1]) <= 180 ? point : null;
  };
  const distance = (a,b) => {
    const rad = x => x * Math.PI / 180;
    const h = Math.sin(rad(b[0]-a[0])/2)**2 + Math.cos(rad(a[0]))*Math.cos(rad(b[0]))*Math.sin(rad(b[1]-a[1])/2)**2;
    return 6371*2*Math.asin(Math.sqrt(Math.min(1,h)));
  };
  // Only the two explicitly designated pilot houses lead the unfiltered list.
  const pilotRank = card => {
    if(card.dataset.type!=='Franchisé')return 2;
    const name=normalize(card.dataset.name),city=normalize(card.dataset.city);
    if(name.includes('maison de beaute') && city==='paris' && /paris\s*16\b/.test(name))return 0;
    if(name==='maison de beaute simone mahler bordeaux' && city==='bordeaux')return 1;
    return 2;
  };
  let leafletPromise;
  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (!leafletPromise) leafletPromise = new Promise((resolve,reject) => {
      const css = document.createElement('link');
      css.rel='stylesheet'; css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      css.integrity='sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';css.crossOrigin=''; document.head.append(css);
      const script=document.createElement('script');
      script.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.integrity='sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';script.crossOrigin='';
      script.onload=()=>resolve(window.L);script.onerror=()=>{leafletPromise=null;script.remove();reject(new Error('Carte indisponible'));};document.head.append(script);
    });
    return leafletPromise;
  }
  class Locator extends HTMLElement {
    saveSearch(){
      try{sessionStorage.setItem('sm-locator-search',JSON.stringify({url:location.pathname+location.search,query:this.query.value,type:this.type.value,booking:this.booking.checked,origin:this.origin,scroll:window.scrollY,listScroll:this.results.scrollTop}));}catch(e){}
    }
    async connectedCallback() {
      if(this.initialized)return;this.initialized=true;
      this.abort=new AbortController();const signal=this.abort.signal;
      this.addEventListener('click',e=>{
        const card=e.target.closest('[data-page-url]');if(!card)return;
        const link=e.target.closest('a');
        if(!link || new URL(link.href,location.href).pathname===new URL(card.dataset.pageUrl,location.href).pathname)this.saveSearch();
      },{signal,capture:true});
      // Delegation also covers paginated cards and cloned map popup cards.
      this.addEventListener('click',e=>{
        if(e.defaultPrevented || e.button!==0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)return;
        if(e.target.closest('a,button,input,select,textarea,label,details'))return;
        const card=e.target.closest('[data-page-url]');
        if(card && !window.getSelection()?.toString())window.location.assign(card.dataset.pageUrl);
      },{signal});
      this.results=this.querySelector('.sm-locator__results');this.status=this.querySelector('[data-status]');
      this.query=this.querySelector('input[type=search]');this.type=this.querySelector('select[data-type]');this.booking=this.querySelector('[data-booking]');
      const params=new URLSearchParams(location.search);this.query.value=params.get('ville')||params.get('q')||'';
      this.cards=[...this.querySelectorAll('[data-institut]')];
      this.querySelector('.sm-locator__controls').hidden=false;this.querySelector('.sm-locator__map-panel').hidden=false;this.querySelector('.sm-locator__view-switch').hidden=false;
      this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();this.searchCity();},{signal});
      this.query.addEventListener('input',()=>{this.searchAbort?.abort();this.origin=null;this.filter();},{signal});
      [this.type,this.booking].forEach(el=>el.addEventListener('change',()=>this.filter(),{signal}));
      this.querySelector('[data-reset]').addEventListener('click',()=>{this.searchAbort?.abort();this.query.value='';this.type.value='';this.booking.checked=false;this.origin=null;this.filter();},{signal});
      this.querySelector('[data-geo]').addEventListener('click',()=>this.geolocate(),{signal});
      this.querySelector('[data-load-map]').addEventListener('click',()=>this.openMap(),{signal});
      this.results.addEventListener('click',async e=>{
        const button=e.target.closest('[data-show-map]');if(!button)return;
        const card=button.closest('[data-institut]');this.setView('map');await this.openMap();
        if(this.map){this.map.invalidateSize();this.map.setView(coordinates(card),14);this.markers.get(card)?.openPopup();this.querySelector('[data-map]').scrollIntoView({block:'center'});}
      },{signal});
      this.querySelectorAll('[data-filter-type]').forEach(button=>button.addEventListener('click',()=>{this.type.value=button.dataset.filterType;this.filter();},{signal}));
      this.querySelectorAll('[data-view-button]').forEach(button=>button.addEventListener('click',()=>{
        this.setView(button.dataset.viewButton);
        if(this.dataset.view==='map'){this.openMap();requestAnimationFrame(()=>this.map?.invalidateSize());}
      },{signal}));
      this.prepare();
      if(params.get('retour')==='recherche'){
        try{const saved=JSON.parse(sessionStorage.getItem('sm-locator-search'));
          if(saved && new URL(saved.url,location.origin).pathname===location.pathname){
            this.query.value=saved.query||'';this.type.value=saved.type||'';this.booking.checked=!!saved.booking;
            if(Array.isArray(saved.origin) && saved.origin.length===2 && saved.origin.every(Number.isFinite))this.origin=saved.origin;
            requestAnimationFrame(()=>{this.results.scrollTop=saved.listScroll||0;window.scrollTo(0,saved.scroll||0);});
          }
        }catch(e){}
      }
      this.filter();
      if(this.dataset.tileUrl)this.openMap();
      // Follow Liquid pagination so inactive entries also cannot truncate the network.
      try {
        let next=this.querySelector('[data-next]');const visited=new Set();
        while(next && !signal.aborted){
          const url=new URL(next.href,location.href);if(url.origin!==location.origin || visited.has(url.href))throw new Error('Pagination');visited.add(url.href);
          this.status.textContent='Chargement des instituts…';
          const response=await fetch(url,{signal});if(!response.ok)throw new Error('Chargement');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const section=[...doc.querySelectorAll('sm-store-locator')].find(el=>el.dataset.sectionId===this.dataset.sectionId);if(!section)throw new Error('Section');
          next.remove();section.querySelectorAll('[data-institut]').forEach(card=>this.results.append(card));
          next=section.querySelector('[data-next]');if(next)this.results.append(next);
          this.cards=[...this.querySelectorAll('[data-institut]')];this.prepare();this.filter();
        }
      }catch(e){if(e.name!=='AbortError')this.status.textContent='Chargement partiel. Utilisez le lien « Voir les instituts suivants » pour continuer.';}
    }
    disconnectedCallback(){this.abort?.abort();this.searchAbort?.abort();this.map?.remove();this.initialized=false;this.map=null;}
    prepare(){
      const selected=this.type.value;
      this.type.querySelectorAll('option:not(:first-child)').forEach(o=>o.remove());
      [...new Set(this.cards.map(c=>c.dataset.type).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'fr')).forEach(value=>this.type.add(new Option(value==='Franchisé'?'Maison de beauté Simone Mahler':value==='Dépositaire'?'Institut partenaire':value,value)));
      this.type.value=selected;
      this.cards.forEach(c=>{const button=c.querySelector('[data-show-map]');if(button)button.hidden=!coordinates(c);});
    }
    async searchCity(){
      const query=this.query.value.trim();this.searchAbort?.abort();this.origin=null;
      if(!query){this.filter();return;}
      const task=new AbortController();this.searchAbort=task;
      const timeout=setTimeout(()=>task.abort(),10000);
      this.status.textContent='Recherche dans un rayon de 20 km…';
      try{
        const params=new URLSearchParams({fields:'nom,centre',format:'json'});
        params.set(/^\d{5}$/.test(query)?'codePostal':'nom',query);
        const response=await fetch('https://geo.api.gouv.fr/communes?'+params,{signal:task.signal});
        if(!response.ok)throw new Error('Service');
        const candidates=await response.json();
        const exact=candidates.filter(c=>normalize(c.nom)===normalize(query));
        const choices=exact.length?exact:candidates;
        if(this.searchAbort!==task || !this.isConnected)return;
        if(choices.length!==1){this.status.textContent=choices.length?'Plusieurs communes correspondent : saisissez un nom de ville plus précis.':'Ville introuvable. Saisissez une ville française ou un code postal complet.';return;}
        const coords=choices[0].centre?.coordinates;
        if(!coords || !coords.every(Number.isFinite))throw new Error('Coordonnées');
        this.origin=[coords[1],coords[0]];this.filter();this.revealSearchResults();
      }catch(e){if(this.searchAbort===task && this.isConnected)this.status.textContent='Recherche géographique indisponible. Réessayez ou utilisez « Me localiser ».';}
      finally{clearTimeout(timeout);}
    }
    filter(){
      this.querySelectorAll('[data-filter-type]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filterType===this.type.value)));
      const q=normalize(this.query.value);const tokens=q.split(' ').filter(Boolean);
      this.visible=this.cards.filter(c=>{
        const haystack=normalize(`${c.dataset.city} ${c.dataset.postcode} ${c.dataset.name}`);
        const point=coordinates(c);c.distance=this.origin && point?distance(this.origin,point):Infinity;
        const match=(this.origin ? c.distance<=20 : tokens.every(t=>haystack.includes(t))) && (!this.type.value || c.dataset.type===this.type.value) && (!this.booking.checked || c.dataset.bookable==='true');
        c.hidden=!match;
        const label=c.querySelector('[data-distance]');label.hidden=!Number.isFinite(c.distance);label.textContent=Number.isFinite(c.distance)?`${c.distance.toLocaleString('fr-FR',{maximumFractionDigits:1})} km à vol d’oiseau`:'';return match;
      });
      this.visible.sort((a,b)=>pilotRank(a)-pilotRank(b) || Number(b.dataset.type==='Franchisé')-Number(a.dataset.type==='Franchisé') || (this.origin ? a.distance-b.distance : 0) || a.dataset.name.localeCompare(b.dataset.name,'fr')).forEach(c=>this.results.append(c));
      this.status.textContent=this.visible.length?`${this.visible.length} institut${this.visible.length>1?'s':''}${this.origin?' dans un rayon de 20 km — maisons de beauté en premier':''}`:'Aucun institut trouvé. Essayez une autre ville ou réinitialisez les filtres.';
      if(this.dataset.unconfigured==='true')this.status.textContent='Nos adresses seront disponibles prochainement.';
      this.updateMap();
    }
    geolocate(){
      if(!navigator.geolocation){this.status.textContent='Géolocalisation indisponible. Recherchez votre ville ou code postal.';return;}
      this.searchAbort?.abort();const button=this.querySelector('[data-geo]');button.disabled=true;this.status.textContent='Recherche de votre position…';
      navigator.geolocation.getCurrentPosition(p=>{if(!this.isConnected)return;button.disabled=false;this.origin=[p.coords.latitude,p.coords.longitude];this.query.value='';this.filter();this.revealSearchResults();},()=>{if(!this.isConnected)return;button.disabled=false;this.status.textContent='Position inaccessible ou autorisation refusée. Recherchez votre ville ou code postal.';},{timeout:10000,maximumAge:60000});
    }
    async revealSearchResults(){
      if(!window.matchMedia('(max-width:767px)').matches)return;
      const lifecycle=this.abort;
      // Scroll to the live result count first, keeping it visible above the map.
      const target=this.querySelector('.sm-locator__result-bar');
      const url=tileTemplate(this.dataset.tileUrl);
      const validTiles=url.startsWith('https://') && ['{z}','{x}','{y}'].every(t=>url.includes(t));
      this.setView(validTiles?'map':'list');
      const reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      target?.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
      if(validTiles){await this.openMap();if(this.isConnected && !lifecycle?.signal.aborted)requestAnimationFrame(()=>this.map?.invalidateSize());}
    }
    setView(mode){
      this.dataset.view=mode;
      this.querySelectorAll('[data-view-button]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.viewButton===mode)));
    }
    async openMap(){
      if(this.map)return;if(this.mapTask)return this.mapTask;
      const status=this.querySelector('[data-map-status]');const url=tileTemplate(this.dataset.tileUrl);
      if(!url?.startsWith('https://') || !['{z}','{x}','{y}'].every(t=>url.includes(t))){status.textContent='La carte sera disponible prochainement. Les itinéraires restent accessibles sur chaque fiche.';return;}
      status.textContent='Chargement de la carte…';
      const lifecycle=this.abort;
      this.mapTask=(async()=>{
        try{
          const L=await loadLeaflet();if(!this.isConnected || lifecycle?.signal.aborted)return;
          const container=this.querySelector('[data-map]');container.replaceChildren();
          this.map=L.map(container,{scrollWheelZoom:false}).setView([46.6,2.4],6);
          this.map.attributionControl.setPrefix(false);
          const attribution=document.createElement('span');
          const provider=this.dataset.attribution?.trim();
          if(provider && provider!=='© OpenStreetMap contributors')attribution.append(provider+' · ');
          const osm=document.createElement('a');osm.href='https://www.openstreetmap.org/copyright';osm.target='_blank';osm.rel='noopener';osm.textContent='© OpenStreetMap contributors';attribution.append(osm);
          const tiles=L.tileLayer(url,{attribution:attribution.innerHTML,maxZoom:18});
          tiles.on('tileerror',()=>{status.textContent='Le fond de carte ne peut pas être chargé. Utilisez les fiches et les liens itinéraire.';});tiles.addTo(this.map);
          this.layer=L.layerGroup().addTo(this.map);this.updateMap();status.textContent='';
        }catch(e){status.textContent='Carte indisponible. Réessayez ou utilisez les liens itinéraire.';}
        finally{this.mapTask=null;}
      })();
      return this.mapTask;
    }
    updateMap(){
      if(!this.map)return;const L=window.L;this.layer.clearLayers();this.markers=new Map();const points=[];
      this.visible.forEach((card,index)=>{
        const point=coordinates(card);if(!point)return;points.push(point);
        // Reuse the rendered card, preserving escaped Liquid content and real links.
        const popup=card.cloneNode(true);popup.removeAttribute('id');popup.removeAttribute('tabindex');popup.removeAttribute('hidden');popup.hidden=false;
        popup.classList.add('sm-locator__popup-card');
        // Leaflet stops popup clicks from bubbling to the locator.
        popup.addEventListener('click',e=>{
          if(!popup.dataset.pageUrl || e.defaultPrevented || e.button!==0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)return;
          if(e.target.closest('a,button,input,select,textarea,label,details') || window.getSelection()?.toString())return;
          e.stopPropagation();window.location.assign(popup.dataset.pageUrl);
        });
        popup.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
        popup.querySelectorAll('[data-show-map]').forEach(node=>node.remove());
        const popupKind=card.dataset.type==='Franchisé'?'sm-popup--franchise':'sm-popup--partner';
        const marker=L.marker(point,{title:card.dataset.name+' — '+(card.dataset.type==='Franchisé'?'Maison de beauté Simone Mahler':'Institut partenaire'),icon:L.divIcon({className:'sm-locator__pin ' + (card.dataset.type==='Franchisé'?'sm-locator__pin--franchise':'sm-locator__pin--depositaire'),html:(()=>{const node=document.createElement(card.dataset.type==='Franchisé'?'img':'span');if(card.dataset.type==='Franchisé'){node.src=this.dataset.symbolUrl;node.alt='';node.width=24;node.height=26;}else node.textContent='D';return node;})(),iconSize:[36,36]})}).bindPopup(popup,{className:popupKind,maxWidth:320,minWidth:240,maxHeight:460,autoPanPadding:[24,24]}).addTo(this.layer);this.markers.set(card,marker);
      });
      if(points.length)this.map.fitBounds(L.latLngBounds(points),{padding:[32,32],maxZoom:13});else this.map.setView([46.6,2.4],6);
    }
  }
  if(!customElements.get('sm-store-locator'))customElements.define('sm-store-locator',Locator);
})();
